import React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker/es";
import "react-datepicker/dist/react-datepicker.css";

import "./TicketRule.sass";
import { ticketRuleTypes } from "../../../constants/ticketRuleTypes";
import { Counter } from "../../Counter/Counter";
import { getCurrencieLabel } from "../../../constants/currencies";

const TicketRule = (props) => {
  const { id, startDate, endDate, price, description, type, count, status } = props.rule;

  const { currency } = props.currentEvent;

  return (
    <div className="ticket-rule">
      <div className="ticket-rule__wrap">
        {status === 'new' ? (
          <h2 className='header'>New ticket rule</h2>
        ) : (
          <h2 className='header'>Ticket rule #{`${id}`.split('').reduceRight((a, v, i) => { return (`${id}`.length - i - 1) % 3 === 0 ? a + ' ' + v : a + v }, '').split('').reduceRight((a, v) => a + v, '')}</h2>
        )}
        <button
          className="close"
          onClick={() => {
            props.remove(id);
          }}
        />
        <div className="ticket-rule__row">
          <div className="ticket-rule__block">
            <label >Type</label>
            <div className='typeSelect'>
              <Select
                options={ticketRuleTypes}
                value={ticketRuleTypes.find(o => o.value === type)}
                onChange={v => props.onChange(id, "type", v.value)}
                classNamePrefix="custom-select"
                className="custom-select"
              />
            </div>
          </div>
        </div>

        {
          (type === 1 || type === 2)
          && <div className="ticket-rule__row">
            <div className='ticket-rule__block ticket-rule-counter'>
              <label>From tickets count</label>
              <Counter
                value={count}
                onValueChange={v => props.onChange(id, "count", v)}
              />
            </div>

            <div className="ticket-rule__block">
              <label>Discount {type === 1 && <>, {getCurrencieLabel(currency)} </> || <>, %</>}</label>
              <input
                type="text"
                placeholder="Enter discount"
                value={price}
                onChange={(event) => {
                  props.onChange(id, "price", event.target.value);
                }}
              />
            </div>
          </div>
        }


        {
          type === 0 && <>
            <div className="ticket-rule__row">
              <div className="ticket-rule__block">
                <label>Start</label>
                <DatePicker
                  selected={startDate}
                  onChange={(value) => {
                    props.onChange(id, "startDate", value);
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  placeholderText="Select start date"
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                />
              </div>
              <div className="ticket-rule__block">
                <label>End</label>
                <DatePicker
                  selected={endDate}
                  onChange={(value) => {
                    props.onChange(id, "endDate", value);
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  placeholderText="Select end date"
                  dateFormat="h:mm a d MMM yyyy "
                  timeCaption="time"
                />
              </div>
            </div>
          </>
        }

        {type === 0
          && <div className="ticket-rule__row">
            <div className="ticket-rule__block" style={{width:'100%'}}>
              <label>Message</label>
              <textarea
                placeholder="Enter message"
                value={description}
                onChange={(event) => {
                  props.onChange(id, "description", event.target.value);
                }}
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default TicketRule;
